"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_1 = require("react-router");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var Routes_1 = require("../../../../common/enum/Routes");
var UrlParamTypes_1 = require("../../../../common/enum/UrlParamTypes");
var paymentType_1 = require("../../../common/constants/paymentType");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var collectedFilters_1 = require("../../../../common/service/collectedFilters");
var react_router_dom_1 = require("react-router-dom");
var useEnquiryNextStep = function (journeyType) {
    var history = react_router_1.useHistory();
    var paymentProvider = usePlatformConfig_1.default().platformConfig.paymentProvider;
    var token = collectedFilters_1.default().filters.token;
    var location = react_router_dom_1.useLocation();
    var isPaymentEnabled = journeyType === globalTypes_1.JourneyType.reserve_online &&
        [paymentType_1.default.WEBPAY, paymentType_1.default['2C2P'], paymentType_1.default.VISANET, paymentType_1.default.MERCADOPAGO].includes(paymentProvider);
    var pathname = !!isPaymentEnabled ? Routes_1.Routes.PAYMENT : Routes_1.Routes.CONFIRMATION_REQUEST_QUOTE;
    var goToNextStep = react_1.useCallback(function (data) {
        var _a;
        history.push(__assign(__assign({}, location), { pathname: pathname, search: "?" + UrlParamTypes_1.UrlParamTypes.TOKEN + "=" + token, state: {
                from: location.pathname,
                previousTransactions: (_a = data) === null || _a === void 0 ? void 0 : _a.previousTransactions,
            } }));
    }, [token]);
    return { goToNextStep: goToNextStep };
};
exports.default = useEnquiryNextStep;
